import React, { useState } from "react";
import "../../styles/Modal.scss";
import name from "../Icons/name.png";
import bkash from "../Icons/bkash.png";
import lead from "../Icons/lead.png";
import thana from "../Icons/Admin.png";
import district from "../Icons/district.png";
import assigned from "../Icons/home_work.png";
import address from "../Icons/Location.png";
import spot from "../Icons/spot.png";
import axios from "axios";
import { CircularProgress, Collapse } from "@material-ui/core";
import ValidationQueriesModal from "./ValidationQueriesModal";
import RejectionNotesModal from "./RejectionNotesModal";
import { useNotification } from "../../../Notifications/NotificationProvider";

const ReviewModal = ({
  isOpen,
  onClose,
  selectedReviewItem,
  maxRevaldiationCount,
}) => {
  const dispatchNotification = useNotification();
  const [action, setAction] = useState(""); // State to store the action (approve or reject)
  const [isLoading, setIsLoading] = useState(false);
  const [Message, setMessage] = useState(null);
  const [response, setResponse] = useState(null);
  const [isQueryModalOpen, setIsQueryModalOpen] = useState(false);
  const [rejectionNoteInput, setRejectionNoteInput] = useState("");

  const [isRejectionNotesModalOpen, setRejectionNotesModalOpen] =
    useState(false);

  const openValidationQueriesModal = () => {
    setIsQueryModalOpen(true);
  };

  const handleRejectionNoteChange = (e) =>
    setRejectionNoteInput(e.target.value);
  const handleReviewAction = async (action) => {
    try {
      setIsLoading(true);

      const requestBody = {
        lead_id: selectedReviewItem.calls__data?.id,
        action: action,
        note: rejectionNoteInput,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/ekyc/v1/review-validation-call`,
        requestBody,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      );

      setResponse(response); // Set the response state

      if (response.status === 200) {
        //console.log("Review action successful");
        dispatchNotification({
          type: "SUCCESS",
          message: `Successfully ${action}`,
        });
        setMessage("Review action successful!");
        setIsLoading(false);
      } else {
        console.error("Error performing review action:", response.data);
        setMessage(response.data.message);
      }
    } catch (error) {
      console.error("Error performing review action:", error);
      setMessage("Error performing review action");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    isOpen &&
    selectedReviewItem && (
      <div className="modal">
        <div className="modal-content" style={{ position: "relative" }}>
          {isLoading && (
            <div className="activity-overlay">
              <CircularProgress style={{ color: "#e2136e" }} />
            </div>
          )}
          <div className="close-button" onClick={onClose}>
            <span>&times;</span>
          </div>
          <div className="header">
            <p>Review Validation</p>
            {/* Add button to open Validation Queries Modal */}
            <button
              onClick={openValidationQueriesModal}
              className="review-valid-queries"
            >
              Open Queries
            </button>
          </div>

          <Collapse in={Message !== null}>
            <div
              className={`assign-msg ${
                response?.status === 200 ? "green-bg" : "red-bg"
              }`}
            >
              {Message}
            </div>
          </Collapse>

          <div className="section">
            <div className="left-section">
              <div className="detail">
                <strong className="field-heading">
                  <img src={name} alt="Field Icon" className="field-icon" />
                  Name
                </strong>
                <div>{selectedReviewItem.lead_name || "Name"}</div>
              </div>
              <div className="detail">
                <strong className="field-heading">
                  <img src={bkash} alt="Field Icon" className="field-icon" />
                  Wallet Number
                </strong>
                <div>{selectedReviewItem.lead_number || "Wallet Number"}</div>
              </div>
              <div className="detail">
                <strong className="field-heading">
                  <img src={lead} alt="Field Icon" className="field-icon" />
                  Lead Generated
                </strong>
                <div>
                  {selectedReviewItem.submission_date ||
                    "Sample Lead Generated"}
                </div>
              </div>
              <div className="detail">
                <strong className="field-heading">
                  <img src={lead} alt="Field Icon" className="field-icon" />
                  Date Assigned
                </strong>
                <div>
                  {selectedReviewItem.assigned_time__date ||
                    "Sample Date Assigned"}
                </div>
              </div>
              <div className="detail">
                <strong className="field-heading">
                  <img src={lead} alt="Field Icon" className="field-icon" />
                  Date Validated
                </strong>
                <div>
                  {selectedReviewItem.calls__data?.upload_time ||
                    "Sample Date Validated"}
                </div>
              </div>
              <div className="detail">
                <strong className="field-heading">
                  <img src={thana} alt="Field Icon" className="field-icon" />
                  Thana/Upazilla
                </strong>
                <div>{selectedReviewItem.thana || "Thana/Upazilla"}</div>
              </div>
              <div className="detail">
                <strong className="field-heading">
                  <img src={district} alt="Field Icon" className="field-icon" />
                  District
                </strong>
                <div>{selectedReviewItem.district || "District"}</div>
              </div>
            </div>
            <div className="right-section">
              <div className="detail">
                <strong className="field-heading">
                  <img src={spot} alt="Field Icon" className="field-icon" />
                  Spot Code
                </strong>
                <div>{selectedReviewItem.spot_code || "Spot Code"}</div>
              </div>
              <div className="detail">
                <strong className="field-heading">
                  <img src={assigned} alt="Field Icon" className="field-icon" />
                  Assigned MAO
                </strong>
                <div>
                  {selectedReviewItem.assigned_field_force__name ||
                    "Abdur Rahim"}
                </div>
              </div>
              <div className="detail">
                <strong className="field-heading">
                  <img src={address} alt="Field Icon" className="field-icon" />
                  Old Address
                </strong>
                <div>
                  {selectedReviewItem.calls__data?.address || "Old Address"}
                </div>
              </div>
              <div className="detail">
                <strong className="field-heading">
                  <img src={address} alt="Field Icon" className="field-icon" />
                  New Address
                </strong>
                <div>
                  {selectedReviewItem.calls__data?.updated_address ?? "null"}
                </div>
              </div>

              <div className="image-section">
                <div className="image-row">
                  <div className="image-container">
                    <img
                      className="image"
                      src={
                        selectedReviewItem.calls__data?.outlet_image ||
                        "https://images.sampletemplates.com/wp-content/uploads/2021/05/Building-Handover-Report.jpg"
                      }
                      alt="Old Address"
                    />
                    <p className="image-name">Outlet Image</p>
                  </div>
                </div>
              </div>
              <div className="button-section">
                <button
                  className="accept-button"
                  onClick={() => {
                    handleReviewAction("approved");
                  }}
                >
                  Approve
                </button>
                <button
                  className="reject-button"
                  onClick={() => {
                    setRejectionNotesModalOpen(true);
                    // handleReviewAction("rejected");
                  }}
                >
                  Reject
                </button>
                {
                  <button
                    className="revalidate-button"
                    onClick={() => {
                      handleReviewAction("revalidated");
                    }}
                    disabled={
                      selectedReviewItem &&
                      selectedReviewItem.revalidated_count >=
                        maxRevaldiationCount
                    }
                  >
                    Revalidate
                  </button>
                }
              </div>
            </div>
          </div>
          {isQueryModalOpen && (
            <ValidationQueriesModal
              isOpen={isQueryModalOpen}
              onClose={() => setIsQueryModalOpen(false)}
              validationQueries={selectedReviewItem.calls__data?.feedback}
            />
          )}
          {isRejectionNotesModalOpen && (
            <RejectionNotesModal
              isOpen={isRejectionNotesModalOpen}
              onClose={() => setRejectionNotesModalOpen(false)}
              noteInput={rejectionNoteInput}
              handleInputChange={handleRejectionNoteChange}
              onOk={() => handleReviewAction("rejected")}
            />
          )}
        </div>
      </div>
    )
  );
};

export default ReviewModal;
